import React from "react";

const ProjectQaNdtBookingsNdtTypesIndex = React.lazy(() => import("./index"));
const NewProjectQaNdtBookingsNdtTypes = React.lazy(() => import("./new"));
const EditProjectQaNdtBookingsNdtTypes = React.lazy(() => import("./edit"));

export default [
  { path: "/project/qa/ndt_bookings/ndt_types/:id/edit", component: EditProjectQaNdtBookingsNdtTypes, name: "Edit ProjectQaNdtBookingsNdtType" },
  { path: "/project/qa/ndt_bookings/ndt_types/new", component: NewProjectQaNdtBookingsNdtTypes, name: "New ProjectQaNdtBookingsNdtType" },
  { path: "/project/qa/ndt_bookings/ndt_types", component: ProjectQaNdtBookingsNdtTypesIndex, name: "ProjectQaNdtBookingsNdtTypes" },
];
